module.exports = __webpack_public_path__ + "static/media/2.c547eb4a.png";